module.exports = __webpack_public_path__ + "static/memory_img1@2x-b91c000e81f8239d31862d3cad5ca318.png";